module.exports = __webpack_public_path__ + "img/nav-wishlist@2x.46dd059.jpg";